import store from '../../redux/store';
import { showMessageModal } from '../../redux/actions';
import { updateAddressAndShop, isObjectNotNull, sendCloudWatchLogs } from '../../utils';
import { ORDER_TYPE_DELIVERY } from '../../constants';

export const onChooseShop = async (component, shop) => {
  try {
    const { showAddressModal, showChooseShop } = component.props;
    const { delivery } = store.getState().configurationReducer;
    const { addressTemp } = store.getState().componentReducer;
    const { chooseShop } = delivery;
    const { address } = shop;
    component.setState({
      loading: true
    });
    let customerAddress = address;
    if (isObjectNotNull(addressTemp)) {
      customerAddress = addressTemp;
    }
    await updateAddressAndShop(
      shop.shopId,
      customerAddress,
      chooseShop && customerAddress.orderType === ORDER_TYPE_DELIVERY
        ? ORDER_TYPE_DELIVERY
        : customerAddress.orderType
    );
    showAddressModal(false);
    showChooseShop(false);
    component.setState({
      loading: false
    });
  } catch (error) {
    sendCloudWatchLogs(`Could not change shop ${error}`);
    store.dispatch(showMessageModal(error));
    component.setState({
      loading: false
    });
  }
};
